(function($) {

    'use strict';

    var ConfirmPassword = function(element, options) {
        this.$element   = $(element);
        this.options    = options;

        this.$verificationCode = $("input[id$='verification_code']");
        this.$password = this.$element.find('input[type="password"]');
        this.$form = $('[data-confirm-password]');
    };

    ConfirmPassword.DEFAULTS = {
        'url' : '/customer/address/checkpassword/',
    };
    ConfirmPassword.prototype.showModalForm = function() {        
        var errorClasses = '.is-invalid, .parsley-error, .parsley-email-exists';
        if (this.$element.find(errorClasses).length > 0) {
            return;
        }

        $('body').modal('destroy');
        $('body').removeData('dft.modal');
        $('body').modal({
            'remote': this.options.url,
            'className' : 'myaccount-confirm-password-modal'
        });
    };

    ConfirmPassword.prototype.load = function() {
        if (this.$password.val().length === 0 || this.$verificationCode.val().length === 0) {
            return false;
        }
        var args = {
            'password': this.$password.val()
        };
        $(this).confirmPassword('loaded', args);
    };

    ConfirmPassword.prototype.loaded = function(args) {
        this.$element.find('.errorMessage').remove();

        $("#integrity-form").val(args.password);
        $("#password-form").val(args.password);
        $("#verification-code-form").val(this.$verificationCode.val());

        this.$form.addClass('password-confirmed');
        this.$form.addClass('is-valid');
        this.$form.submit();
    };

    ConfirmPassword.prototype.invalidField = function(response, field) {
        var message = JSON.parse(response.responseText).message;

        field.after('<div class="errorMessage">' + message + '</div>');
    };

    ConfirmPassword.prototype.invalidPassword = function(response) {
        var message = JSON.parse(response.responseText).message;

        this.$password.removeClass('is-valid').addClass('is-invalid');
        this.$password.after('<div class="errorMessage">' + message + '</div>');
    };

    $.fn.confirmPassword = function(option, args) {
        return this.each(function () {
            var $this   = $(this);
            var data    = $this.data('dft.confirm-password');
            var options = $.extend({}, args, $this.data(), typeof option == 'object' && option);

            if (!data) $this.data('dft.confirm-password', (data = new ConfirmPassword(this, options)));
            if (typeof option == 'string') data[option](args);
        });
    };

    $(document).on('submit', '[data-confirm-password]:not(.password-confirmed)', function(e) {
        e.preventDefault();
        var data = this.getAttribute("data-confirm-password");
        var url = '/customer/' + data + '/checkpassword/';

        var args = {
            'url': url
        };
       
        if (($(this).attr('data-confirm-password') == 'account' && $(this).is('.is-email-valid')) ||
            ($(this).attr('data-confirm-password') == 'address')) {
            $(this).confirmPassword('showModalForm', args);
        }
    });

    $(document).on('submit', '[data-myaccount-confirm-password-form]', function(e) {
        e.preventDefault();

        var args = {
            'url':  $(this).attr('action')
        };
        $(this).confirmPassword('load', args);
    });
})(jQuery);